import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TargetDetailsModalPageRoutingModule } from './target-details-modal-routing.module';

import { TargetDetailsModalPage } from './target-details-modal.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TargetDetailsModalPageRoutingModule,
    TranslateModule
  ],
  declarations: [TargetDetailsModalPage]
})
export class TargetDetailsModalPageModule { }
